import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Subway,AirportShuttle,SupervisedUserCircle,Edit,Delete,SwapHoriz,Done,OpenInBrowser,CancelPresentation,AccountBalanceWallet} from '@material-ui/icons';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Link,
  CircularProgress
} from "@material-ui/core";


import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";


import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService,FinanceService} from "./../../utils/web_config_2";

import { useHistory } from "react-router-dom";
import UserInfo from './login_info';

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow:1,
        [theme.breakpoints.up('sm')]:{
          marginLeft:250,
        }
      },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
,balance:{
  height:180
}
}));

 function Transactions() {
  const classes = useStyles1();

  const history = useHistory();

  const [agentData, setAgentData] = useState({});
  const [agentProfile,setAgentProfile]=useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [transactionMessage,setTransactionMessage]=useState("Loading...");


  /// transaction table 




  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display:false,
       filter: true,
       sort: true,
      }
     },
    {
     name: "reference_number",
     label: "Reference Number",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
        name: "external_reference_number",
        label:"External Reference",
        options: {
         filter: true,
         sort: true,
        }
       }
       ,{
     name: "credited_account",
     label:"Credited Account",
     options: {
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        
       return(
       <Link
       component="button"
       variant="body2"
       onClick={() => {
        setAccountNumber(value);
         get_balance(value);
       }}
     >
       {value}
     </Link>);
       
     }
     }
    },{
     name: "debited_account",
     label:"Debited Account",
     options: {
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        
        return(
        <Link
        component="button"
        variant="body2"
        onClick={() => {
         setAccountNumber(value);
          get_balance(value);
        }}
      >
        {value}
      </Link>);
        
      }
     }
    },
    {
      name: "channel_type",
      label: "Channel",
      options: {
       filter: true,
       sort: false,
      }
     },
    {
        name: "amount",
        label: "amount",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "total_commission_amount",
        label: "Total Commission",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "commission_value",
        label: "Commission Value",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "created_at",
        label: "Date/Time",
        options: {
         filter: true,
         sort: false,
        }
       },
       {
        name: "status",
        label: <Translate id="agent_transaction.table_transaction.status" />,
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => {
           if(value=="COMPLETED"){
            return (
              <Chip
              color="primary"
              label={value}
              icon={<Done />}
            ></Chip>
                
            );
           }else{
            return (
              <Chip
              color="primary"
              label={value}
              onDelete={()=>{}}
              deleteIcon={<Done />}
            ></Chip>
                
            );
           }
          
        }
        }
       }
   ];

   const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "stacked",
    selectableRows: false,
    elevation:0
  };

useEffect(()=>{
  var data = {};
  const profileData=JSON.parse(localStorage.getItem("agent_profile"));
  setAgentProfile(profileData);
  const data1 = localStorage.getItem("nx_ag");
  if (data1 != null) {
    data = JSON.parse(data1);
  }
  setAgentData(data);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  get_transaction(data.token);
},[]);


// get transactions

const [transactions,setTransactions]=useState([]);
const [transactionLoad,setTransactionLoad]=useState(false);

const get_transaction=(token)=>{
  setTransactionMessage("Loading...");
  setTransactionLoad(true);
  const transactionInstance = axios.create(new FinanceService().setHeaders(token));
  transactionInstance .get('/api/v1/getAgentTransactions/'+new UserInfo().CODE)
  .then(res=>{
    setTransactionLoad(false);
    var objs=res.data.data;
    if(objs.length==0){
      enqueueSnackbar("No transactions available!",
        {
          variant: 'Info'
      });
      setTransactionMessage("No transactions available!");
    }else{
      setTransactions(objs);
    }

  }).catch(err=>{
    
    setTransactionLoad(false);
    if (err.response.status == 401) {
      history.push("/", { expired: true });
      enqueueSnackbar("Your session has expired", {
        variant: "error",
        
      });
    }

    if (err.response.status == 404) {
      enqueueSnackbar("No transactions available", {
        variant: "info",
      });
    }

  });

}



// dialog balance

const [balanceDialog,setBalanceDialog]=useState(false);

// get balance
const [accountNumber,setAccountNumber]=useState("");
const [balanceData,setBalanceData]=useState({
  opening_balance: 0,
  current_balance: 0,
  closing_balance: 0
});
const [balanceLoad,setBalanceLoad]=useState(false);
const get_balance=(account_number)=>{
setBalanceLoad(true);
setBalanceDialog(true);
const balanceInstance = axios.create(new FinanceService().setHeaders(agentData.token));
balanceInstance.get('/api/v1/getAccountBalance/'+account_number)
  .then(res=>{
    var data=res.data.data;
    setBalanceData(data);
    setBalanceLoad(false);
  }).catch(err=>{

    setBalanceLoad(false);
    enqueueSnackbar(err.message,
      { 
        variant: 'error'
    });

    if (err.response.status == 401) {
      history.push("/", { expired: true });
      enqueueSnackbar("Your session has expired", {
        variant: "error",
        
      });
    }
    
  });
}




  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <SwapHoriz fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b><Translate id="agent_transaction.transactions"/></b></Typography>

 </Box>
 

 
     </Box>

 {/* vehicles table  */}

 <Box mt={2}>
 {transactionLoad&&<LinearProgress />}
 <MUIDataTable
  title={<Translate id="agent_transaction.transaction_list"/>}
  data={transactions}
  columns={columns}
  options={options}
/>
 </Box> 



{/* balance dialog */}


<Dialog
    maxWidth="sm"
    fullWidth
        open={balanceDialog}
        onClose={()=>{
          setBalanceDialog(false);
        }}
        aria-labelledby="agent_information"
        aria-describedby="agent_information"
      >
        <DialogTitle >Account Balance</DialogTitle>
        <DialogContent>
          <DialogContentText >
          
          {balanceLoad?
          <Box display="flex" justifyContent="center">
          <CircularProgress fontSize="large"/>
        </Box>
        :
        <Box >
       
       


      <Box
        display="flex"
        alignItems="flex-end"
        p={1}
        mt={1}
        justifyContent="center"
        
      >
        <Box width="70%"display="flex" justifyContent="center"  p={1} bgcolor="grey.300">
          <Box >
          {accountNumber}
          </Box>
          
        </Box>
          </Box>




          <List >

          <ListItem>
        <ListItemAvatar>
            <AccountBalanceWallet />
        </ListItemAvatar>
        <ListItemText primary="Current Balance" secondary={balanceData.current_balance+"FRW"} />
      </ListItem>

      <ListItem>
        <ListItemAvatar>
            <OpenInBrowser />
        </ListItemAvatar>
        <ListItemText primary="Opening Balance" secondary={balanceData.opening_balance+"FRW"} />
      </ListItem>

      <ListItem>
        <ListItemAvatar>
            <CancelPresentation />
        </ListItemAvatar>
        <ListItemText primary="Closing Balance" secondary={balanceData.closing_balance+"FRW"}/>
      </ListItem>
      
    </List>


          </Box>

        }
          


          </DialogContentText>
          </DialogContent>
        <DialogActions>
         
          <Button onClick={()=>{
          setBalanceDialog(false);
          }} color="secondary">
          Close
          </Button>

         
        </DialogActions>
      </Dialog>



    </div>
  );
}
export default withLocalize(Transactions);